var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiskLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 80,
    viewBox: "0 0 100 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3773_415125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3773_415125",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 50C90 42.9771 88.151 36.078 84.6389 29.9964C81.1268 23.9147 76.0755 18.865 69.9927 15.3548L61.9956 29.2129C65.6453 31.319 68.6761 34.3488 70.7834 37.9978C72.8906 41.6468 74 45.7863 74 50H90Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90 50C90 42.9771 88.151 36.078 84.6389 29.9964C81.1268 23.9147 76.0755 18.865 69.9927 15.3548L61.9956 29.2129C65.6453 31.319 68.6761 34.3488 70.7834 37.9978C72.8906 41.6468 74 45.7863 74 50H90Z",
    fill: "#FF5C5C",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_3773_415125)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_3773_415125",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.9879 15.352C63.9047 11.8427 57.0047 9.99682 49.9819 10C42.959 10.0032 36.0607 11.8553 29.9807 15.3702L37.9884 29.2221C41.6364 27.1132 45.7754 26.0019 49.9891 26C54.2029 25.9981 58.3428 27.1056 61.9928 29.2112L69.9879 15.352Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.9879 15.352C63.9047 11.8427 57.0047 9.99682 49.9819 10C42.959 10.0032 36.0607 11.8553 29.9807 15.3702L37.9884 29.2221C41.6364 27.1132 45.7754 26.0019 49.9891 26C54.2029 25.9981 58.3428 27.1056 61.9928 29.2112L69.9879 15.352Z",
    fill: "#FAB816",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-2-inside-2_3773_415125)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_3773_415125",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9796 15.3708C23.8997 18.8858 18.8523 23.9396 15.3451 30.024C11.8379 36.1085 9.99441 43.0091 10 50.0319L26 50.0192C25.9966 45.8054 27.1027 41.6651 29.2071 38.0144C31.3114 34.3638 34.3398 31.3315 37.9878 29.2225L29.9796 15.3708Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.9796 15.3708C23.8997 18.8858 18.8523 23.9396 15.3451 30.024C11.8379 36.1085 9.99441 43.0091 10 50.0319L26 50.0192C25.9966 45.8054 27.1027 41.6651 29.2071 38.0144C31.3114 34.3638 34.3398 31.3315 37.9878 29.2225L29.9796 15.3708Z",
    fill: "#02C3AB",
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-3-inside-3_3773_415125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8467 65.5234V67H38.8428V65.5234H43.8467ZM39.4102 57.0469V67H37.5303V57.0469H39.4102ZM44.6465 63.377V63.2334C44.6465 62.6911 44.724 62.1921 44.8789 61.7363C45.0339 61.276 45.2594 60.8773 45.5557 60.54C45.8519 60.2028 46.2142 59.9408 46.6426 59.7539C47.071 59.5625 47.5586 59.4668 48.1055 59.4668C48.6615 59.4668 49.1536 59.5625 49.582 59.7539C50.015 59.9408 50.3796 60.2028 50.6758 60.54C50.972 60.8773 51.1976 61.276 51.3525 61.7363C51.5075 62.1921 51.585 62.6911 51.585 63.2334V63.377C51.585 63.9147 51.5075 64.4137 51.3525 64.874C51.1976 65.3298 50.972 65.7285 50.6758 66.0703C50.3796 66.4076 50.0173 66.6696 49.5889 66.8564C49.1605 67.0433 48.6706 67.1367 48.1191 67.1367C47.5723 67.1367 47.0824 67.0433 46.6494 66.8564C46.2165 66.6696 45.8519 66.4076 45.5557 66.0703C45.2594 65.7285 45.0339 65.3298 44.8789 64.874C44.724 64.4137 44.6465 63.9147 44.6465 63.377ZM46.4512 63.2334V63.377C46.4512 63.7005 46.4831 64.0036 46.5469 64.2861C46.6107 64.5687 46.7087 64.8171 46.8408 65.0312C46.973 65.2454 47.1439 65.4141 47.3535 65.5371C47.5677 65.6556 47.8229 65.7148 48.1191 65.7148C48.4108 65.7148 48.6615 65.6556 48.8711 65.5371C49.0807 65.4141 49.2516 65.2454 49.3838 65.0312C49.5205 64.8171 49.6208 64.5687 49.6846 64.2861C49.7484 64.0036 49.7803 63.7005 49.7803 63.377V63.2334C49.7803 62.9144 49.7484 62.6159 49.6846 62.3379C49.6208 62.0553 49.5205 61.807 49.3838 61.5928C49.2516 61.374 49.0785 61.2031 48.8643 61.0801C48.6546 60.9525 48.4017 60.8887 48.1055 60.8887C47.8138 60.8887 47.5632 60.9525 47.3535 61.0801C47.1439 61.2031 46.973 61.374 46.8408 61.5928C46.7087 61.807 46.6107 62.0553 46.5469 62.3379C46.4831 62.6159 46.4512 62.9144 46.4512 63.2334ZM54.9551 65.2227L56.5752 59.6035H57.7236L57.3818 61.5449L55.748 67H54.7568L54.9551 65.2227ZM54.0596 59.6035L55.2764 65.2363L55.3857 67H54.2441L52.3027 59.6035H54.0596ZM59.2275 65.1543L60.417 59.6035H62.167L60.2393 67H59.0977L59.2275 65.1543ZM57.9014 59.6035L59.5078 65.168L59.7197 67H58.7285L57.0811 61.5449L56.7461 59.6035H57.9014Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7554 39.642C51.486 40.0534 53.3661 42.6005 52.9547 45.3311C52.5433 48.0617 49.9962 49.9418 47.2656 49.5304C44.535 49.119 17.2019 39.9445 17.2019 39.9445C17.2019 39.9445 46.0248 39.2306 48.7554 39.642Z",
    fill: "#5E6C84"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.844,
    cy: 44.7119,
    r: 2,
    transform: "rotate(-81.4321 48.844 44.7119)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3773_415125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskLow);
export default __webpack_public_path__ + "static/media/risk_low.b296c2078d2ffc9f19a44a49693e1895.svg";
export { ForwardRef as ReactComponent };